<template>
  <div class="wrap">
    <div class="query-banner">
      <div class="banner-center">
        <div class="banner-center-title">合作伙伴</div>
      </div>
    </div>
    <div v-if="$route.path != '/proxy'" class="search-view">
      <a-form layout="inline">
        <a-form-item label="">
          <a-input
            v-model:value="partnerform.companyName"
            placeholder="请输入合作伙伴名称"
            allow-clear
            @clear="clear"
          ></a-input>
          <div class="a-div">
            无代理商省份如有考试需求，请联系下方“统信软件教育与考试中心”微信号
          </div>
        </a-form-item>
        <a-form-item>
          <a-button type="primary" @click="search">查询</a-button>
        </a-form-item>
      </a-form>
    </div>
    <div class="partner-content">
      <router-view></router-view>
      <div class="shamTableHead" v-if="$route.path != '/proxy'">
        <a-select
          v-model:value="partnerform.province"
          show-search
          placeholder="省份"
          style="width: 165px;borderRight: 1px solid #fff;"
          :options="provinceArr"
          :filter-option="filterOption"
          @change="handleTableHeadChange"
          allowClear
        ></a-select>
        <a-select
          v-model:value="partnerform.city"
          show-search
          placeholder="城市"
          style="width: 165px;borderRight: 1px solid #fff;"
          :options="cityArr"
          :filter-option="filterOption"
          @change="handleTableHeadChange"
          allowClear
        ></a-select>
        <a-select
          v-model:value="partnerform.companyName"
          show-search
          placeholder="合作伙伴名称"
          style="width: 333px;borderRight: 1px solid #fff;"
          :options="companyNameArr"
          :filter-option="filterOption"
          @change="handleTableHeadChange"
          allowClear
        ></a-select>
        <!-- <a-select
          v-model:value="partnerform.partnerType"
          show-search
          placeholder="代理类型"
          style="width: 165px;borderRight: 1px solid #fff;"
          :options="agentTypeArr"
          :filter-option="filterOption"
          @change="handleTableHeadChange"
          allowClear
        ></a-select> -->
        <div style="width: 165px;border-right: 1px solid #fff;float: left;font-weight: bold;height: 63px;line-height:63px;text-align:center;">代理类型</div>
        <a-select
          v-model:value="partnerform.address"
          show-search
          placeholder="地址"
          style="width: 333px;borderRight: 1px solid #fff;"
          :options="addressArr"
          :filter-option="filterOption"
          @change="handleTableHeadChange"
          allowClear
        ></a-select>
        <a-select
          v-model:value="partnerform.userName"
          show-search
          placeholder="联系人"
          style="width: 165px;borderRight: 1px solid #fff;"
          :options="userNameArr"
          :filter-option="filterOption"
          @change="handleTableHeadChange"
          allowClear
        ></a-select>
        <a-select
          v-model:value="partnerform.tel"
          show-search
          placeholder="联系方式"
          style="width: 165px;"
          :options="telArr"
          :filter-option="filterOption"
          @change="handleTableHeadChange"
          allowClear
        ></a-select>
      </div>
      <a-table
        v-if="$route.path != '/proxy'"
        size="large"
        :data-source="partnerlist"
        row-key="id"
        :pagination="pagination"
        @change="changeTable"
      >
        <a-table-column
          key="province"
          title="省份"
          data-index="province"
          align="center"
          :width="165"
        />
        <a-table-column
          key="city"
          title="地市"
          data-index="city"
          align="center"
          :width="165"
        />
        <a-table-column
          key="companyName"
          title="合作伙伴名称"
          align="center"
          :width="333"
        >
          <template v-slot="scope">
            <!-- <span class="new_span">
              <router-link
                :to="
                  '/proxy?id=' +
                    scope.record.id +
                    '&companyName=' +
                    scope.record.companyName
                "
              >
                {{ scope.record.companyName }}
              </router-link>
            </span> -->
            <span>{{ scope.record.companyName }}</span>
          </template>
        </a-table-column>
        <a-table-column
          key="partnerType"
          title="代理类型"
          align="center"
          :width="165"
        >
          <template v-slot="scope">
            <span v-if="scope.record.partnerType == 1">
              钻石代理商商
            </span>
            <span v-if="scope.record.partnerType == 0">
              金牌代理商商
            </span>
            <span v-if="scope.record.partnerType == 2">
              银牌代理商商
            </span>
          </template>
        </a-table-column>
        <a-table-column
          key="address"
          title="地址"
          data-index="address"
          align="center"
          :width="333"
        />
        <a-table-column
          key="userName"
          title="联系人"
          data-index="userName"
          align="center"
          :width="165"
        />
        <a-table-column
          key="tel"
          title="联系方式"
          data-index="tel"
          align="center"
          :width="165"
        />
      </a-table>
      <p v-if="$route.path != '/proxy'" class="new_p">
        <!-- 注：钻石代理商下属的银牌代理商信息需点击具体合作伙伴名称后展示 -->
      </p>
    </div>
  </div>
</template>
<script>
import { getpartners, getPartnerQueryPage,queryPartnerHeaderInfo } from "@/request/partners";
export default {
  name: "",
  props: {},
  data() {
    return {
    addressArr:[],//地址
    cityArr:[],//城市
    companyNameArr:[],//合作伙伴名称
    provinceArr:[],//省份
    agentTypeArr:[
      { value: '1', label: '钻石代理商商' },
      { value: '0', label: '金牌代理商商' },
      // { value: '2', label: '银牌代理商商' },
    ],//代理类型
    telArr:[],
    userNameArr:[],
      pagination: {
        pageSize: 10, // 一页的数据限制
        current: 1, // 当前页
        total: 0,
      },
      partnerlist: [],
      partnerform: {
        // partnerLevel:"0",
        province: undefined,
        city: undefined,
        companyName: undefined,
        tel:undefined,
        address:undefined,
        userName:undefined,
        // partnerType:"1",
        pageIndex: "1",
        pageSize: "10",
        cooperationStatus: "1",
      },
    };
  },
  methods: {
    clear(val) {},
    changeTable(pagination, sorter) {
      console.log("这是我的分页", pagination);
      // this.pagination.pageIndex = current;
      this.partnerform.pageIndex = pagination.current;
      // this.pagination.pageSize = pageSize;
      this.partnerform.pageSize = pagination.pageSize;
      this.search();
      window.scrollTo(0, 0);
    },
    search() {
      this.getPartnerList().then((res) => {
        if (res.data) {
          if (res.data.data) {
            this.pagination.total = res.data.data.totalCount;
            this.pagination.current = res.data.data.currPage;
            this.pagination.pageSize = res.data.data.pageSize;
          }
        }
      });
    },
    async getHeaderInfoFun(){
      const res = await queryPartnerHeaderInfo()
      if(res.data.data.address!=null){
        res.data.data.address.forEach(item => {
          let addressObj = {}
          addressObj.value = item
          addressObj.label = item
          this.addressArr.push(addressObj)
        });
      }
      if(res.data.data.city!=null){
        res.data.data.city.forEach(item => {
          let cityObj = {}
          cityObj.value = item
          cityObj.label = item
          this.cityArr.push(cityObj)
        });
      }
      if(res.data.data.companyName!=null){
        res.data.data.companyName.forEach(item => {
          let companyNameObj = {}
          companyNameObj.value = item
          companyNameObj.label = item
          this.companyNameArr.push(companyNameObj)
        });
      }
      if(res.data.data.province!=null){
        res.data.data.province.forEach(item => {
          let provinceObj = {}
          provinceObj.value = item
          provinceObj.label = item
          this.provinceArr.push(provinceObj)
        });
      }
      if(res.data.data.tel!=null){
        res.data.data.tel.forEach(item => {
          let telObj = {}
          telObj.value = item
          telObj.label = item
          this.telArr.push(telObj)
        });
      }
      if(res.data.data.userName!=null){
        res.data.data.userName.forEach(item => {
          let userNameObj = {}
          userNameObj.value = item
          userNameObj.label = item
          this.userNameArr.push(userNameObj)
        });
      }
    },
    async getPartnerList() {
      const res = await getPartnerQueryPage(this.partnerform);
      if (res) {
        console.log(res);
        if (res.data.code == 0) {
          this.partnerlist = [];
          let begin = [];
          let end = [];
          res.data.data.list.forEach((item) => {
            if (item.partnerType == 1) {
              begin.push(item);
            } else {
              end.push(item);
            }
          });
          begin.push(...end);
          console.log(begin, end);
          this.partnerlist = begin;
        } else {
          this.$message.error(res.data.msg);
        }
        return res;
      }
    },
    handleTableHeadChange(){
      this.search()
    },
    filterOption(input, option){
      return option.value.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    },
  },
  mounted() {
    this.search();
    this.getHeaderInfoFun()
  },
};
</script>
<style lang="scss" scoped>
@import "./index.scss";
</style>
